// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"Banner_bannerWrapper__ej1ZD","title":"Banner_title__oAMtU","news":"Banner_news__JJhY4","button":"Banner_button__cwxq+","filler":"Banner_filler__D6-N4"};